import axios from 'axios';

import { CONFIG } from '@arrived/config';

interface SignUpBody {
  email: string;
  password: string;
}

export interface SignUpReturn {
  _id: string;
  email: string;
}

export const postSignUp = async (signUpBody: SignUpBody) => {
  const auth0PassedBody = {
    ...signUpBody,
    client_id: CONFIG.auth0.clientId,
    connection: CONFIG.auth0.connection,
  };
  const response = await axios.post<SignUpReturn>(`/dbconnections/signup`, auth0PassedBody, {
    baseURL: CONFIG.auth0.domain,
  });

  return response.data;
};
